// Base API client for making requests to the DMT API

// Set the base URL based on environment
const API_BASE_URL = process.env.NODE_ENV === 'production' 
  // ? 'https://your-production-api-url.com' // Replace with actual production URL
  ? 'https://okanxcz59i.execute-api.us-east-1.amazonaws.com/dev/api' // Replace with actual production URL
  : 'http://localhost:3004/api';

// Get auth token from local storage (this would be set during login)
const getAuthToken = () => {
  return localStorage.getItem('authToken');
};

// Common headers for all requests
const getHeaders = () => {
  const headers = {
    'Content-Type': 'application/json',
  };
  
  const token = getAuthToken();
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  return headers;
};

// Generic request method
const request = async (endpoint, options = {}) => {
  const url = `${API_BASE_URL}${endpoint}`;
  // console.log({url})
  const defaultOptions = {
    headers: getHeaders(),
  };
  
  const fetchOptions = {
    ...defaultOptions,
    ...options,
  };

  try {
    // console.log({fetchOptions})

    const response = await fetch(url, fetchOptions);
    // console.log({response})
    const data = await response.json();
    // console.log(data)
    
    // Check if the response contains an error
    if (response.status >= 400) {
      throw new Error(data.body?.error || data.body?.message || 'An unknown error occurred');
    }
    
    return data;
  } catch (error) {
    console.error(`API request failed: ${error.message}`);
    throw error;
  }
};

// HTTP method wrappers
const api = {
  get: async (endpoint, params = {}) => {
    // console.log('get')
    // Build query string
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        queryParams.append(key, value);
      }
    });
    
    const queryString = queryParams.toString();
    const url = queryString ? `${endpoint}?${queryString}` : endpoint;
    // console.log({url})
    
    const resp = await request(url, { method: 'GET' });
    // console.log({resp})
    return resp;
  },
  
  post: async (endpoint, data) => {
    return await request(endpoint, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },
  
  put: async (endpoint, data) => {
    return await request(endpoint, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },
  
  delete: async (endpoint) => {
    return await request(endpoint, {
      method: 'DELETE',
    });
  },
};

// Browser sessions API functions
export const browserSessionsApi = {
  getBrowserSessions: async () => {
    return await api.get('/browser-sessions');
  },
};

export default api;